webpackJsonp([279379153958506,143228886497844],{

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stand.24277b75.png";

/***/ }),

/***/ 1602:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1603:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_insert_vend.b9feb6a0.jpg";

/***/ }),

/***/ 1604:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAsCAMAAABG6/YeAAAA81BMVEUAAABCsExCsExBsEtCsExCsExEtE5GtFBCsEtBsEtCsUxDsUxhz2FBsEtBsEtCsEtYxFhCsUxBsEtBsExCsUtDr01DsUtDsU5Esk1EsU5Br0v////k9OZEsE79/v2T0Zlvwne34LtWuF+n2qze8d/N6tCy3rb0+vWW05t7x4JyxHnB5cWMz5KEy4t/yYZjvmxGsVD4/Pnt+O7o9ena79zG58mb1aFnv29QtVpIslLx+fHU7dfL6c2m2aua1J92xX3h8+PX7tmv3bNswXNMtFbQ69O14Lmi2KeQ0JZcumXq9uvP6tG44by24Lpdu2W44bt4xn++S8OUAAAAGnRSTlMAmq74gXYjHfW1TkQF39iqCIrLx2ljX1w4MZBk23sAAAL+SURBVFjDvZfpctowEIBNCklD0qbp3V1MiEONMTc2BocrXAk52/d/mq4l2ZLHnsmfqN8MaDGSP0m7MoNhGCfnB29MoWykKYAGDk5VxVfQQlF1fAYtvDtUHO9AD8eKA3RR/g+OD5/0O6Cow2F1Oi6AknYNjgvECigca3cQZf0OSrt+BxT1Oyjt+h1wrN1BlPU6ZNrj74OgCzHNIHBY4K79h8rjugccJwgm0LPrw6ldgwT3afXg2718BxSlo4U4mIh420BsUWs9oqAVAmFSVHOq7Er1Lj7cK9HnMsw6RNpF2KOh8bAFjRgDvAyRGDSQWIXC8Yde3NJhfcfXGDN1Uo6JTDvIhVyHLOrTvUfU1Oluz/cA1i1yv8mcewus/QCxzvreIHXujmtOBXGoOO493PV5eJg4xtT5gkVtijYAe2raycIGlnBs2JUuXyrMaR68U/8JUXFcytHfZF2NED0TCJrajDcjEPjk544ZMEzawS41NPVbEJemqsNOdhO+S8dYXG1GmaXFUtMEQUA35w4HOHVmdWkZFgiWqsPyqy2Th0fSATO+xzSdnVB5FQHbaeaIC5xKbs6qdQUx5iCVc2GAM/UMbugWS/buiqyoXIvaBc5vxCuWjmdI8PJq9/0Rd8hxuygtUyA6tA2XCvM8xxpxDQk3eY6SkXLUooxUo8UQLn2YgEKe444fVkEjx/HxNO2AHTtfPj/sFLmvOZq0h6acYo7jxFAcYu6ymnyldsNWM9expTS3Zc1kHWfZZ3tU4nURt2UV9Ud0DPIcQI+ARg8YDkqHTHjWsVSq04yeJfM+Ra5P0TLXYTVIsrAg3LSoT8ZRyvutXeFNEvcaSOPqMw/Z2ct1QLOK8VNyOJcOmfCs4y8ddSnxksPRzM850W2IPl5vLx0y4VkHLEyQ9Bd1thRHFPHatq04W7a95NHk6iGaxdUWxra9yCZcdeQT3lsmvMb2hU8im3Dh0EbJ0O2ghOt3nOj/r3ZgSL6AFijhkh+ghZKhcg4aKBhpfpUKb0zxZ0rwD+VdrN3X1jvbAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/video_thumbnail_granadilla.9a3f3968.jpg";

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(49);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _pageHeaderBanner = __webpack_require__(159);
	
	var _pageHeaderBanner2 = _interopRequireDefault(_pageHeaderBanner);
	
	var _videoSection = __webpack_require__(117);
	
	var _videoSection2 = _interopRequireDefault(_videoSection);
	
	var _section = __webpack_require__(23);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _custom_a = __webpack_require__(83);
	
	var _custom_a2 = _interopRequireDefault(_custom_a);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _verticalTickBox = __webpack_require__(116);
	
	var _verticalTickBox2 = _interopRequireDefault(_verticalTickBox);
	
	var _video_thumbnail_granadilla = __webpack_require__(1605);
	
	var _video_thumbnail_granadilla2 = _interopRequireDefault(_video_thumbnail_granadilla);
	
	var _image_insert_vend = __webpack_require__(1603);
	
	var _image_insert_vend2 = _interopRequireDefault(_image_insert_vend);
	
	var _stand = __webpack_require__(1594);
	
	var _stand2 = _interopRequireDefault(_stand);
	
	var _avatar_nicHarry = __webpack_require__(1602);
	
	var _avatar_nicHarry2 = _interopRequireDefault(_avatar_nicHarry);
	
	var _logo_vend = __webpack_require__(1604);
	
	var _logo_vend2 = _interopRequireDefault(_logo_vend);
	
	var _yocoMerchant = __webpack_require__(152);
	
	var _yocoMerchant2 = _interopRequireDefault(_yocoMerchant);
	
	var _SEOInfo = __webpack_require__(19);
	
	var _SEOInfo2 = _interopRequireDefault(_SEOInfo);
	
	var _columnInfoBox = __webpack_require__(91);
	
	var _columnInfoBox2 = _interopRequireDefault(_columnInfoBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerBannerProps = {
	  pageSubheader: "Vend + Yoco",
	  textColor: "black",
	  bgColor: "#f6f6f6",
	  pageText: _react2.default.createElement(
	    "p",
	    null,
	    "Retail solutions at your fingertips with Yoco Payments and Vend POS software. ",
	    _react2.default.createElement("br", null),
	    "* Currently only available using the new Vend Register iPad app."
	  )
	};
	
	var tickBox = ["Sell in-store, online and on-the-go", "Access and manage your inventory anywhere, anytime - all on the cloud", "Track sales, revenue and profit margins and make smarter, more profitable decisions", "Scale up by adding products, staff, registers and stores, in just a few clicks"];
	
	var costInfo = [{
	  heading: "Automation saves time",
	  paragraph: "Managing payment reconciliations, cash-ups and more all in one platform."
	}, {
	  heading: "Happy staff & customers",
	  paragraph: "Less time spent on tasks means more time to spend on your customers' experience."
	}, {
	  heading: "Less risk of fraud",
	  paragraph: "Data from till balances is fed directly to the POS and compared without manual input."
	}, {
	  heading: "Reporting made easy",
	  paragraph: "Instant access to your business sales, staff performance and stock levels."
	}];
	
	var IndexPage = function IndexPage(props) {
	  var location = props.location;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(_SEOInfo2.default, {
	      title: "Vend",
	      description: "",
	      canonicalLink: location.pathname
	    }),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(_pageHeaderBanner2.default, _extends({ pageLogo: _logo_vend2.default }, headerBannerProps)),
	    _react2.default.createElement(
	      _section2.default,
	      { className: "pt-4 pb-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(_columnInfoBox2.default, {
	            data: costInfo,
	            headerStyle: { fontWeight: "bold" }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 pt-4" },
	          _react2.default.createElement("img", { src: _image_insert_vend2.default, alt: "could not load image" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _section2.default,
	      { textAlign: "left" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-7" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "PARTNER FEATURES"
	            ),
	            _react2.default.createElement(
	              "h3",
	              { className: "pr-0" },
	              "Vend is one of the leading point of sale software for retailers."
	            ),
	            _react2.default.createElement(_verticalTickBox2.default, {
	              data: tickBox,
	              tickStyle: { marginTop: "35px", marginLeft: "7px" }
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-5 pl-md-5" },
	            _react2.default.createElement(_Image2.default, { src: _stand2.default })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _section2.default,
	      {
	        header: "YOCO + VEND INTEGRATION",
	        subHeader: "What our merchants are saying.",
	        bgColor: "#F6F6F6"
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(_yocoMerchant2.default, null),
	          _react2.default.createElement(_yocoMerchant2.default, {
	            avatar: _avatar_nicHarry2.default,
	            paragraph: "Working with Yoco through our Vend point of sale is simple and extremely efficient. Switching apps as we've had to do in the past wasn't a sustainable way to complete transactions. Now with the Yoco/Vend integration the customer checkout process is seamless.",
	            merchantName: "NIC HARRY"
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_videoSection2.default, {
	      header: ["TESTIMONIAL VIDEO"],
	      subHeader: ["Granadilla Swimwear uses Yoco + Vend"],
	      paragraph: ["Icing brownie halvah pastry souffle oat cake desert. Tootsie roll candy canes cake. Toffee tiramisu marshmallow pie"],
	      youtubeVideoId: "MhjTJUqogjg",
	      previewImage: _video_thumbnail_granadilla2.default,
	      bgColor: "#FFFFFF"
	    }),
	    _react2.default.createElement(
	      _section2.default,
	      { bgColor: "#DEE6E9" },
	      _react2.default.createElement(_custom_a2.default, null)
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Move to /components
	var YocoMerchant = function YocoMerchant(_ref) {
	  var avatar = _ref.avatar,
	      merchantName = _ref.merchantName,
	      paragraph = _ref.paragraph;
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-4" },
	    _react2.default.createElement(
	      "p",
	      null,
	      avatar && _react2.default.createElement(_Image2.default, { src: avatar })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      paragraph
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      merchantName
	    )
	  );
	};
	
	exports.default = YocoMerchant;
	module.exports = exports["default"];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerBanner = __webpack_require__(32);
	
	var _headerBanner2 = _interopRequireDefault(_headerBanner);
	
	var _aphrodite = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageHeaderBanner = function (_HeaderBanner) {
	  _inherits(PageHeaderBanner, _HeaderBanner);
	
	  function PageHeaderBanner(props) {
	    _classCallCheck(this, PageHeaderBanner);
	
	    return _possibleConstructorReturn(this, _HeaderBanner.call(this, props));
	  }
	
	  PageHeaderBanner.prototype.render = function render() {
	    var _props = this.props,
	        pageLogo = _props.pageLogo,
	        pageSubheader = _props.pageSubheader,
	        pageText = _props.pageText;
	
	    return _react2.default.createElement(
	      "section",
	      {
	        style: {
	          backgroundColor: this.props.bgColor ? this.props.bgColor : "#BDB5B2",
	          color: this.props.textColor ? this.props.textColor : "white",
	          textAlign: "center"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row " + (0, _aphrodite.css)(styles.bannerStyle) },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "pt-md-5" },
	              _react2.default.createElement("img", {
	                src: pageLogo,
	                className: "pt-5 pb-4 text-right",
	                alt: "Image not yet available"
	              }),
	              _react2.default.createElement(
	                "h1",
	                { className: "pt-4 pb-4" },
	                pageSubheader
	              ),
	              pageText
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return PageHeaderBanner;
	}(_headerBanner2.default);
	
	exports.default = PageHeaderBanner;
	
	
	var styles = _aphrodite.StyleSheet.create({
	  bannerStyle: {
	    minHeight: "450px",
	    color: "#0c0c0c",
	    marginRight: "-25px!important",
	    marginLeft: "-25px!important"
	  },
	  fontStyle: {
	    fontWeight: "normal"
	  }
	});
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-za-integrations-vend-index-js-ff9f49fd4399c966a2a0.js